import React from 'react';

import { Children } from '../../../types';

const ListHeader = ({ children }) => <div className="list__header">{children}</div>;

ListHeader.propTypes = { children: Children.isRequired };

export default React.memo(ListHeader);
